module.exports = __webpack_public_path__ + "img/laji.2a81bbcb.jpg";